import MDBox from 'src/components/md/MDBox';
import MDTypography from 'src/components/md/MDTypography';
import Modal from 'src/components/modal/Modal';
import { Grid } from '@mui/material';
import SalesOrderView from './SalesOrderView';
import useSalesOrder, {
  SalesOrderStatus,
} from 'src/api/accounts-receivable/sales-orders/useSalesOrder';

interface Props {
  salesOrderId: string;
  refetchSalesOrders?: () => void;
  onClose: (refetch?: boolean) => void;
  hideSuggestedActions?: boolean;
}

const SalesOrderModal: React.FC<Props> = ({
  salesOrderId,
  refetchSalesOrders,
  onClose,
  hideSuggestedActions,
}) => {
  const { data, isLoading, error, refetch } = useSalesOrder(salesOrderId);

  const loading = isLoading;

  const salesOrder = data?.salesOrder;

  // TODO this should be a field on the SO from the BE, i.e. "salesOrder.isEditable"
  const editable = salesOrder?.status === SalesOrderStatus.pending;

  const handleUpdate = () => {
    refetch();
    refetchSalesOrders?.();
  };

  return (
    <Modal
      maxWidth={'xl'}
      fullScreenable
      disableContentOverflow={!salesOrder?.originSyncStatus}
      open={true}
      title={
        <MDBox
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <MDTypography variant="h6">
            {`Sales Order #${salesOrder?.internalId}`}
          </MDTypography>
        </MDBox>
      }
      closeable
      isLoading={loading}
      error={error}
      onCloseButton={{
        text: 'Close',
        onClick: onClose,
        disabled: loading,
      }}
      hideCloseButton
      openToPath={{
        to: '/sales-orders/$salesOrderId',
        params: {
          salesOrderId: salesOrder?.id,
        },
      }}
    >
      <MDBox sx={{ height: '100%', overflow: 'hidden' }}>
        {salesOrder ? (
          <Grid
            container
            spacing={2}
            sx={{ height: '100%', overflow: 'hidden' }}
          >
            <Grid
              item
              xs={hideSuggestedActions ? 12 : 8}
              sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}
            >
              <SalesOrderView
                salesOrder={salesOrder}
                editable={editable}
                onUpdate={handleUpdate}
              />
            </Grid>
            {hideSuggestedActions ? null : (
              <Grid
                item
                xs={4}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              ></Grid>
            )}
          </Grid>
        ) : (
          <MDBox
            display="flex"
            justifyContent="center"
            alignItems="center"
            height="100%"
          >
            {/* Empty state or loading placeholder */}
          </MDBox>
        )}
      </MDBox>
    </Modal>
  );
};

export default SalesOrderModal;
